let _get = null;

export default function CloudServerApi($get) {
  _get = $get;
}

function middleware(url, params, type = 'act') {
  if (_get) {
    return _get('/creator/', {
      [type]: url,
      ...params,
    });
  } else {
    return console.warn('function _get is undefined!');
  }
}

export const cloudApi = {
  cloudBuy: params => middleware('cloud_buy', params),
  cloudRenew: params => middleware('cloud_update', params),
  cloudSearch: params => middleware('cloud_search', params),
  getCloudList: params => middleware('get_cloud_list', params),
  getPayCode: params => middleware('get_cloud_pay_code', params),
  getCloudConfig: params => middleware('get_cloud_config', params),
  getPayState: params => middleware('get_cloud_pay_state', params),
  getCloudDetails: params => middleware('get_cloud_detail', params),
  getCloudAdData: params => middleware('get_cloud_data_ad', params),
  exportCloudData: params => middleware('export_cloud_data', params),
  getCloudOverview: params => middleware('get_cloud_overview', params),
  getCloudBaseData: params => middleware('get_cloud_data_base', params),
  getCloudOrderList: params => middleware('get_cloud_order_list', params),
  getCloudOrderDetails: params => middleware('get_cloud_order_detail', params),
  exportCloudOrderList: params => middleware('export_cloud_order_list', params),
};
